<template>
  <b-container class="overall-bg pb-0">
    <b-row>
      <b-col>
        <BacktoPage :goback="$router.back"></BacktoPage>
        <b-row> </b-row>
      </b-col>
    </b-row>
  </b-container>
  <b-container class="form-white-bg">
    <div class="d-flex justify-content-between align-items-center">
      <p class="common-heading1 mb-4">Items part of the request</p>
      <div>
        <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
      </div>
    </div>
    <TabView class="tabview-custom" ref="tabview4">
      <TabPanel>
        <template #header>
          <i class="pi pi-box pe-3"></i>
          <span>Items
            <Badge :value="items.length" severity="warning"></Badge>
          </span>
        </template>
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0" eheader="OutBound Request Items" econtent="OutBound Request Items"
              eimg="/src/assets/Img/icons/request.svg" @createNew="" />
            <!-- {{ items }} -->
            <Tableview v-model:value="items" :paginator="false" class="p-datatable-gridlines mt-5" :rows="10"
              dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
              :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters">
              <template v-slot:Add> </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" />
                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0" eheader="OutBound Request Items" econtent="OutBound Request Items"
              eimg="/src/assets/Img/icons/request.svg" @createNew="" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item["ItemCode"] }} /</p>
                    <p class="light-name">{{ item["HSNCode"] }}</p>
                    <p class="light-name" v-if="item['IssueCode']">
                      / {{ item["IssueCode"] }}
                    </p>
                  </div>
                  <p class="name">{{ item["Itemname1"] }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Requested Quantity :</p>
                    <p class="small-name">
                      {{ item["ItemQuantity"] ? item["ItemQuantity"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Received Quantity :</p>
                    <p class="small-name">
                      {{ item["IssueQty"] ? item["IssueQty"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Returns :</p>
                    <p class="small-name">
                      {{ item["Returns"] ? item["Returns"] : "0" }}
                    </p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>

        <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
          :content="$t('confirmation.editcontent')" />
        <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
        <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
        <!-- </div> -->
      </TabPanel>
      <!-- <TabPanel>
        <template #header>
          <i class="pi pi-align-left pe-3"></i>
          <span>Logs
            <Badge :value="0" severity="warning"></Badge>
          </span>
        </template>
        <Log v-for="item in headers" />
      </TabPanel> -->
    </TabView>
  </b-container>
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, computed } from "vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Log from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute } from "vue-router";
import commonService from "../../../../../../../modules/Inventory/Service/IndentTemplateService";
import { useRouter } from "vue-router";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import RequestFlowChart from "../../../../../../../components/Chart/RequestFlowChart.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import DetailsBanner from "../../../../../../../modules/Inventory/components/Transaction/detailsbanner.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    Log,
    Loader,
    RequestFlowChart,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    DetailsBanner,
    CrystalReportPrintPopUp
  },
  setup() {
    const routes = useRoute();
    let IndentTemplateId = routes.query.indentTemplateid;
    let status = routes.query.status ?? 0;
    const dataEdit = ref({});
    const Editmodel = ref(false);
    // const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const router = useRouter();
    let requestid = ref("");
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      IsShow();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });


    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    const menu = ref();
    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },
          // {
          //     label: "Cancel PO",
          // },
        ],
      },
    ]);
    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      tostoreid: "",
      id: ref(),
      date: ref(),
    });
    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };
    const headers = [
      {
        header: "Code",
        field: "ItemProductId",
      },
      // {
      //   header: "HSN",
      //   field: "HSNCode",
      // },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass text_overflow1",
        class: "smallwidth",
      },
      // {
      //   header: "Issue Id",
      //   field: "IssueCode",
      //   bodyclass: "bluecolor",
      // },

      {
        header: "Req Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "UOM",
        field: "UOMName",
        class: "smallwidth",
      },
      {
        header: "Unit Rate",
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Rate",
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Received Qty",
      //   field: "IssueQty",
      //   bodyclass: "boldclass right_td",
      //   class: "smallwidth",
      // },

      // {
      //   header: "Return Qty",
      //   field: "ReturnQty",
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    let loading = ref(false);
    let loading1 = ref(false);
    let items = ref([]);
    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }
    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
        },
      });
    }
    async function IsDelete(data) { }
    async function IsShow() {
      try {
        loading.value = true;
        const result = await commonService.GetByIndentTemplateId(
          IndentTemplateId
        );
        items.value = result["result"];
        console.log(items.value);
        const totalIssueQty = computed(() => {
          return items.value.reduce((sum, item: any) => sum + item.IssueQty, 0);
        });

        const totalItemQty = computed(() => {
          return items.value.reduce(
            (sum, item: any) => sum + item.ItemQuantity,
            0
          );
        });
        requestid.value = result["result"][0].DocNo;
        data.value.fromstr = result["result"][0].FromStoreName;
        data.value.tostr = result["result"][0].ToStoreName;
        data.value.fromstoreid = result["result"][0].FromStoreCode;
        data.value.tostoreid = result["result"][0].ToStoreCode;
        data.value.fromstatus = result["result"][0].FromStoreType;
        data.value.tostatus = result["result"][0].ToStoreType;
        data.value.fromcount = totalItemQty;
        data.value.tocount = totalIssueQty;
        loading.value = false;
      } catch { }
    }

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 103,
      HeaderTitle: "Indent template",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = IndentTemplateId;
      ParameterValues.value.BranchId = usersData.BranchId;
      ParameterValues.value.HospitalId = usersData.OrganizationId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };


    return {
      data,
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      headers,
      filters,
      loading1,
      loading,
      IsShow,
      IsConfirmEdit,
      dataEdit,
      Editmodel,
      deletepop,
      IsConfirmDel,
      closetrigger,
      IsEdit,
      Deletemodel,
      IsDelete,
      requestid,
      windowWidth,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Print
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.Actionsbtn {
  background-color: #0a82ff !important;
  border: none !important;
  padding: 8px !important;
}

// .itempart {}

// .logcard {
//     height: 30px;
// }</style>
